import React from 'react';
import { environments } from '@i18n/environments';
import { xDefaultLanguage } from '@i18n/i18n';
import useCurrentLanguage from '../i18n/useCurrentLanguage';
import useLocationPathName from '../i18n/useLocationPathName';

function HeadLinks() {
  const { esPagesToExclude } = require(`../../workers-site/excludedPages`);
  const alternates = environments[process.env.REACT_APP_ENV]?.alternates ?? [];
  const alternateCopy = [...alternates];
  const defaultLang = alternateCopy.find((x) => x.lang === xDefaultLanguage);
  if (defaultLang) {
    alternateCopy.push({ lang: 'x-default', path: defaultLang.path });
  }

  let locationPathName = useLocationPathName();
  const results = [];
  const { currentLanguage } = useCurrentLanguage();

  alternateCopy
    .filter((alternate) => {
      if (alternate.lang === 'es') {
        if (esPagesToExclude.includes('/' + locationPathName)) {
          return false;
        }
      }
      return true;
    })
    .forEach((x) => {
      let URLcontainsQuestionMark = false;
      if (typeof window !== 'undefined' && window.document) {
        URLcontainsQuestionMark = window.location.href.includes('?');
      }

      if (!URLcontainsQuestionMark && x.lang !== currentLanguage) {
        results.push(<link key={x.lang} rel="alternate" hreflang={x.lang} href={x.path + locationPathName} />);
      }
      if (!URLcontainsQuestionMark && locationPathName.endsWith('/') && x.lang === currentLanguage) {
        results.push(<link key={x.lang} rel="alternate" hreflang={x.lang} href={x.path + locationPathName} />);
      }
      if (typeof window !== 'undefined' && window.document) {
        if (locationPathName === '' && !window?.location.href.includes('?') && x.lang === currentLanguage) {
          results.push(<link key={x.lang} rel="alternate" hreflang={x.lang} href={x.path} />);
        }
      }
    });

  if (currentLanguage) {
    const currentLanguageAlternate = alternates.find((x) => x.lang === currentLanguage);
    if (currentLanguageAlternate) {
      const canonicalUrl = currentLanguageAlternate.path + locationPathName;
      let URLcontainsQuestionMark = false;

      if (typeof window !== 'undefined' && window.document) {
        URLcontainsQuestionMark = window.location.href.includes('?');
      }

      // See ZW-256. Figured with Musa that this should only be added when having ? in the URL as it is not ok to have self referencing canonical BUT we still need it when going on ?
      // See ZW-1700. Musa wants them added back

      results.push(<link rel="canonical" href={canonicalUrl} />);
      results.push(<meta key="og:url" property="og:url" content={canonicalUrl} />);
    }
  }

  return results;
}

export default HeadLinks;
